import {
  Component,
  Inject,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';
import { ActionsFilters } from '../../actions/actions-filter/actions-filter.interface';
import { UtilsService } from '../../shared/utils.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-safety-observations-view-corrective-actions-filter',
  templateUrl:
    './safety-observations-view-corrective-actions-filter.component.html',
  styleUrls: [
    './safety-observations-view-corrective-actions-filter.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SafetyObservationsViewCorrectiveActionsFilterComponent
  implements OnInit {
  filters: ActionsFilters = {
    priority: '',
    status: '0',
    type: ''
  } as ActionsFilters;

  constructor(
    public utils: UtilsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<
      SafetyObservationsViewCorrectiveActionsFilterComponent
    >
  ) {}

  ngOnInit(): void {
    // Set default values if not provided.
    this.filters.priority = this.data['priority'] || '';
    this.filters.status = (this.data['completed'] || 0).toString();
    this.filters.type = this.data['type'] || '';
  }

  /**
   * Clears the filters and closes the form.
   *
   * @return {void}
   */
  onClearAndClose(): void {
    // Clear the filters.
    this.filters.priority = '';
    this.filters.status = '0';
    this.filters.type = '';

    this.onSaveAndClose();
  }

  /**
   * Saves the filters and closes the dialog.
   *
   * @return {void}
   */
  onSaveAndClose(): void {
    let response: any;

    response = {
      priority: this.filters.priority,
      completed: Number(this.filters.status),
      type: this.filters.type
    };

    this.dialogRef.close(response);
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
